// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"22c05282","227":"b0c4e18f"}[chunkId] + ".chunk.css";
};